import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

export async function initNativeShell() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#fafcff' });
  } catch {
    // Status bar styling is optional on some devices.
  }

  try {
    await SplashScreen.hide();
  } catch {
    // Splash may already be hidden.
  }

  CapApp.addListener('backButton', () => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    CapApp.exitApp();
  });
}

export function isNativeApp() {
  return Capacitor.isNativePlatform();
}
